import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { loginRedirect, logout } from "../../../redux/actions/Authentication";
import NavDropdown from "./NavDropdown";

/**
 * Login dropdown based on auth state
 *
 * @param logout
 * @param login
 * @param name
 * @param isLoggedIn
 * @returns {*}
 * @constructor
 */
const NavLogin = ({ logout, login, name, isLoggedIn }) => {
  if (isLoggedIn) {
    return (
      <NavDropdown header={name}>
        <a onClick={logout}>Log out</a>
      </NavDropdown>
    );
  } else {
    return <a onClick={login}>Log in</a>;
  }
};

const mapStateToProps = ({ auth }) => ({
  isLoggedIn: auth.isLoggedIn,
  name: auth.user.name
});

const mapDispatchToProps = dispatch => {
  return {
    login: e => {
      e.preventDefault();
      dispatch(loginRedirect());
    },
    logout: e => {
      e.preventDefault();
      dispatch(logout());
      dispatch(push("/"));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavLogin);



// WEBPACK FOOTER //
// ./src/containers/App/Sidebar/NavLogin.js